import styled from 'styled-components';

import FullWidthSection from '../Layout/FullWidthSection';

const HomepageWave = styled(FullWidthSection)`
  align-self: end;

  img {
    width: 100vw;
  }
`;

export default HomepageWave;
